<script setup lang="ts">
import Loading from '@/components/shared/Loading.vue';

const type = ['button']
</script>

<template>
    <Loading :typeLoading="type"></Loading>
</template>
